module.exports = __webpack_public_path__ + "img/metamask_three.8e2e86c0.png";